import cx from 'classnames';

import { Icon, Text } from '..';

interface TipMessageProps {
  variant?: 'info' | 'warning';
  title?: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * Decentní informační blok (tip / upozornění) — ohraničená karta s ikonou,
 * volitelným titulkem a textem. Vzhled vychází z DeadlineTip.
 */
export const TipMessage: React.FC<TipMessageProps> = (props) => {
  const { variant = 'info', title, children, className } = props;

  return (
    <div className={cx('TipMessage', `TipMessage--${variant}`, className)}>
      <div className="TipMessage__icon">
        <Icon name={variant === 'warning' ? 'flag' : 'info'} />
      </div>
      <div className="TipMessage__body">
        {title && (
          <Text as="div" size="body-medium" weight="600" color="Neutral800">
            {title}
          </Text>
        )}
        <Text as="div" size="body-small" color="Neutral700">
          {children}
        </Text>
      </div>
    </div>
  );
};
